import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Mail, ArrowLeft } from "lucide-react";

export default function AdminForgot() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const clean = (email || "").trim().toLowerCase();
    if (!clean.includes("@")) { toast.error("Please enter a valid email"); return; }
    setLoading(true);
    try {
      await api.post("/auth/forgot", { email: clean });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not send reset link");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[--sanctum-bg]">
      <div className="w-full max-w-sm bg-white rounded-2xl border border-[--sanctum-border] p-8 shadow-[0_20px_60px_rgba(0,0,0,0.05)]">
        <Link
          to="/admin/login"
          className="text-xs text-neutral-500 hover:text-neutral-900 inline-flex items-center gap-1.5 tracking-widest uppercase mb-6"
          data-testid="forgot-back-link"
        >
          <ArrowLeft size={12} strokeWidth={1.5} /> Back to sign in
        </Link>
        <h1 className="font-display text-3xl mb-1">Reset your password</h1>
        <p className="text-sm text-neutral-500 mb-6">
          Enter your admin email. We'll send a link that lets you set a new password. The link is valid for 30 minutes.
        </p>

        {sent ? (
          <div
            data-testid="forgot-sent-panel"
            className="rounded-xl bg-[--sanctum-secondary]/40 p-5 text-sm text-neutral-700 leading-relaxed"
          >
            If that email is on file, a reset link is on its way. Check your inbox (and spam folder) in the next minute or two.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="eyebrow block mb-1.5">Admin email</label>
              <div className="relative">
                <Mail size={14} strokeWidth={1.5} className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400" />
                <input
                  data-testid="forgot-email"
                  type="email" required autoFocus autoComplete="username"
                  value={email} onChange={(e) => setEmail(e.target.value)}
                  className="w-full h-11 pl-9 pr-3 rounded-lg border border-[--sanctum-border] bg-white focus:outline-none focus:border-neutral-400"
                />
              </div>
            </div>
            <button
              type="submit"
              data-testid="forgot-submit"
              disabled={loading}
              className="btn-pill btn-primary w-full mt-6"
            >
              {loading ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
